"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AgGridVue", {
  enumerable: true,
  get: function get() {
    return _agGridVue.default;
  }
});

var _agGridVue = _interopRequireDefault(require("./dist/agGridVue"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/_ag-grid-vue@19.1.2@ag-grid-vue/main.js
// module id = 704
// module chunks = 5